import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {ApiProvider} from "../api/api";
import {Observable} from "rxjs";

/*
  Generated class for the InsuranceProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class InsuranceProvider {

  constructor(public api: ApiProvider) {
  }

  promise: Promise<any>;
  getCompanies() {
    if(!this.promise) {
      this.promise = new Promise((success, reject) => {
        this.api.callGet('/insurance').subscribe(success, reject);
      });
    }
    return this.promise;
  }
}



// WEBPACK FOOTER //
// ./src/providers/insurance/insurance.ts